import firebaseApp from '../firebase/index';
import axios from 'axios';
import { getCurrentUser, getUserIdByPublicAddress } from './user.service';
import { NOTIFY_CATEGORY, NOTIFY_CONTENT_TYPE, NOTIFY_TYPE, status_response } from './constants';
import globalConfig from '../config';
import CustomError from './errors/CustomError';

const FIREBASE_SERVER_URL = globalConfig.FIREBASE_SERVER_URL;
const notiRef = firebaseApp.firestore().collection('notification-info');

/**
 * Get list notification
 * @param {*} type read type: // 1: read notification customer // 2: read notification shop
 * @param {*} readStatus true or false
 * @param {*} from
 * @param {*} limit
 */
const getNotificationList = async function({ readStatus = -1, from = 0, limit = 10 }) {
  try {
    const searchTime = from ? new Date(from) : new Date();
    const userNotifRef = await getCurrentUserNotifications();
    if (readStatus === 1) {
      userNotifRef.where('readStatus', '==', true);
    } else if (readStatus === 0) {
      userNotifRef.where('readStatus', '==', false);
    }
    const querySnapshot = await userNotifRef
      .orderBy('createdAt', 'desc')
      .startAfter(searchTime)
      .limit(limit)
      .get();

    let notifications = [];

    querySnapshot.forEach(doc => {
      const not = doc.data();
      not.id = doc.id;

      notifications.push(not);
    });

    return {
      status: status_response.success,
      result: {
        data: notifications || [],
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Search notification
 * @param {*} type read type: // 1: read notification customer // 2: read notification shop
 * @param {*} keyword keyword for search
 * @param {*} from search after time input
 * @param {*} limit
 * @return array of notification
 * sample data for array of notification:
 * [
 *  {
 *     content: "{
 *      "orderId":40,
 *      "productId":90,
 *      "productName":"Product 001",
 *      "priceUnit":"0",
 *      "quantity":1,
 *      "shipFee":"0",
 *      "totalPrice":"0",
 *      "receiverName":"例）山田太郎",
 *      "phoneNumber":"09012345678",
 *      "deliveryAddress":"例）中央区本町１−１ 第一ビル１０１号室",
 *      "deliveryCity":"秋田県",
 *      "deliveryAddressCode":"123-456",
 *      "txHash":"0xdCad3a6d3569DF655070DEd06cb7A1b2Ccd1D3AF"
 *     }"
 *     contentType: 2
 *     createdAt: {_seconds: 1543942800, _nanoseconds: 0}
 *     id: "DY3hYHBPsnHUpOhXkneZ"
 *     image: "https://www.shopjapan.co.jp/content/dam/shopjapan/share/img/products/500x375/def/def_hero.jpg"
 *     orderId: 40
 *     readStatus: false
 *     title: "40が決済されました。"
 *     type: 1
 *     updatedAt: {_seconds: 1543942800, _nanoseconds: 0}
 *  },
 *  ...
 * ]
 */
const searchNotification = async function({ keyword = '', from = 0, limit = 10 }) {
  try {
    const token = await (await getCurrentUser()).getIdToken();
    keyword = encodeURIComponent(keyword);
    const { data } = await axios({
      method: 'get',
      url: `${FIREBASE_SERVER_URL}/notification/search?keyword=${keyword}&from=${from}&limit=${limit}`,
      headers: {
        Authorization: 'Bearer ' + token
      }
    });
    return {
      status: status_response.success,
      result: {
        data: data, // array of notification
        messageId: 'Successful!'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Get detail notification by id
 * @param {*} id notification id
 * @return object about notification info
 * sample of notification:
 *  {
 *     content: "{
 *      "orderId":40,
 *      "productId":90,
 *      "productName":"Product 001",
 *      "priceUnit":"0",
 *      "quantity":1,
 *      "shipFee":"0",
 *      "totalPrice":"0",
 *      "receiverName":"例山田太郎",
 *      "phoneNumber":"09012345678",
 *      "deliveryAddress":"例）中央区本町１−１ 第一ビル１０１号室",
 *      "deliveryCity":"秋田県",
 *      "deliveryAddressCode":"123-456",
 *      "txHash":"0xdCad3a6d3569DF655070DEd06cb7A1b2Ccd1D3AF"
 *     }"
 *     contentType: 2
 *     createdAt: {_seconds: 1543942800, _nanoseconds: 0}
 *     id: "DY3hYHBPsnHUpOhXkneZ"
 *     image: "https://www.shopjapan.co.jp/content/dam/shopjapan/share/img/products/500x375/def/def_hero.jpg"
 *     orderId: 40
 *     readStatus: false
 *     title: "40が決済されました。"
 *     type: 1
 *     updatedAt: {_seconds: 1543942800, _nanoseconds: 0}
 *  }
 */
const getNotificationDetail = async function(id) {
  try {
    const userNotifRef = await getCurrentUserNotifications();
    const querySnapshot = await userNotifRef.doc(id).get();
    return {
      status: status_response.success,
      result: {
        data: querySnapshot.data() || {},
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Add new notification
 * @param {*} publicAddress address receive notification
 * @param {*} type type of notification: 1 - notification of customer, 2 - notification of shop, 3 - notification of product reviews
 * @param {*} orderId order id
 * @param {*} contentType 1 - Fix Order, 2 - Payment, 3 - Shipped, 4 - Receipt
 * @param data
 */
const addNotification = async function(publicAddress, category = 0, type, orderId, contentType, data) {
  console.log(`notification.service.js - (111) - `, data);
  try {
    const userIdReceive = await getUserIdByPublicAddress(publicAddress);
    console.log(`notification.service.js - (114) - `, publicAddress);
    console.log(`notification.service.js - (114) - `, userIdReceive);
    if (!userIdReceive) {
      throw new CustomError('Receive address not valid!');
    }
    const userNotifRef = notiRef.doc(userIdReceive).collection('notifications');
    const timestamp = new Date();
    const { id } = await userNotifRef.add({
      orderId: orderId,
      title: data.title,
      contentType,
      content: data.content,
      image: data.image,
      readStatus: false,
      type: type,
      category: category,
      createdAt: timestamp,
      updatedAt: timestamp
    });
    return {
      status: status_response.success,
      result: {
        data: id,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Change read status of notification by id from false to true
 * @param {*} id notification id
 */
const changeReadStatusNotification = async function(id) {
  try {
    const userNotifRef = await getCurrentUserNotifications();
    const timestamp = new Date();
    const result = await userNotifRef.doc(id).update({
      readStatus: true,
      updatedAt: timestamp
    });
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Change read status of notification by order from false to true
 * @param {*} orderId
 * @param {*} contentType notification type
 * @param {*} category notification category
 */
const changeReadStatusNotificationByOrder = async function(orderId, contentType, category = null) {
  try {
    let userNotifRef = await getCurrentUserNotifications();
    const timestamp = new Date();
    const querySnapshot = await userNotifRef.where('orderId', '==', orderId).get();

    const ids = [];
    const promises = [];
    const data = {
      readStatus: true,
      updatedAt: timestamp
    };

    if (contentType !== null && contentType !== undefined) {
      querySnapshot.forEach(doc => {
        if (contentType instanceof Array) {
          contentType.map(item => {
            if ('contentType' in doc.data() && doc.data().contentType === item) {
              ids.push(doc.id);
              promises.push(userNotifRef.doc(doc.id).update(data));
            }
          });
        } else if ('contentType' in doc.data() && doc.data().contentType === contentType) {
          ids.push(doc.id);
          promises.push(userNotifRef.doc(doc.id).update(data));
        }
      });
    }

    if (category !== null && category !== undefined) {
      querySnapshot.forEach(doc => {
        if (category instanceof Array) {
          category.map(item => {
            if ('category' in doc.data() && doc.data().category === item) {
              ids.push(doc.id);
              promises.push(userNotifRef.doc(doc.id).update(data));
            }
          });
        } else if ('category' in doc.data() && doc.data().category === contentType) {
          ids.push(doc.id);
          promises.push(userNotifRef.doc(doc.id).update(data));
        }
      });
    }

    if (ids.length) {
      await Promise.all(promises);

      return {
        status: status_response.success,
        result: {
          data: ids,
          messageId: 'success'
        }
      };
    } else {
      return {
        status: status_response.error,
        result: {
          message: 'Not found notification.',
          messageId: error.messageId
        }
      };
    }
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Change read status of notification by order from false to true
 * @param {*} orderId
 */
const changeReadStatusNotificationByOrderOfCustomer = async function(orderId) {
  try {
    let userNotifRef = await getCurrentUserNotifications();
    const timestamp = new Date();
    const querySnapshot = await userNotifRef.where('orderId', '==', orderId).get();

    const ids = [];
    const promises = [];
    const data = {
      readStatus: true,
      updatedAt: timestamp
    };

    querySnapshot.forEach(doc => {
      console.log(JSON.stringify(doc.data(), null, 2));
      if (
        'category' in doc.data() &&
        NOTIFY_CATEGORY.ORDER === doc.data().category &&
        NOTIFY_TYPE.CUSTOMER === doc.data().type
      ) {
        ids.push(doc.id);
        promises.push(userNotifRef.doc(doc.id).update(data));
      }
    });

    if (ids.length) {
      await Promise.all(promises);

      return {
        status: status_response.success,
        result: {
          data: ids,
          messageId: 'success'
        }
      };
    } else {
      return {
        status: status_response.error,
        result: {
          message: 'Not found notification.',
          messageId: error.messageId
        }
      };
    }
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Read time update for notification
 * @param {*} callback callback function when has new notification
 */
const registerNotificationListener = async function(callback) {
  try {
    const userNotifRef = await getCurrentUserNotifications();
    userNotifRef.where('readStatus', '==', false).onSnapshot(
      querySnapshot => {
        callback(querySnapshot.size);
      },
      error => {} // Handle error
    );
    return {
      status: status_response.success,
      result: {
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

const unsubcribleNoti = async () => {
  const userNotifRef = await getCurrentUserNotifications();
  userNotifRef.onSnapshot(function() {})();
};

/**
 * Get ref to notification collection by id current user
 */
const getCurrentUserNotifications = async function() {
  const { uid: userId } = await getCurrentUser();
  return notiRef.doc(userId).collection('notifications');
};

export {
  getNotificationList,
  getNotificationDetail,
  addNotification,
  changeReadStatusNotification,
  changeReadStatusNotificationByOrder,
  changeReadStatusNotificationByOrderOfCustomer,
  registerNotificationListener,
  unsubcribleNoti,
  searchNotification
};
